var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.getWrapperClass() },
    [
      _vm.label
        ? _c(
            "label",
            { staticClass: "data-label", class: { regular: _vm.regularLabel } },
            [_vm._v(" " + _vm._s(_vm.label) + " ")]
          )
        : _vm._e(),
      _c("div", { staticClass: "position-relative" }, [
        _c("textarea", {
          staticClass: "form-control",
          class: { "was-Invalidated": _vm.error },
          attrs: {
            id: _vm.id,
            disabled: _vm.disabled,
            maxlength: _vm.maxlength,
            placeholder: _vm.placeholder,
            rows: _vm.rows
          },
          domProps: { value: _vm.value },
          on: {
            input: function($event) {
              return _vm.$emit("input", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _vm.error
          ? _c("i", {
              staticClass: "fa fa-times-circle form-control-icon-invalid"
            })
          : _vm._e(),
        _vm.showCharCount
          ? _c(
              "span",
              { staticClass: "char-count", class: _vm.getCountClasses() },
              [
                _vm.maxlength > 0 && _vm.value
                  ? _c("span", [_vm._v(_vm._s(_vm.value.length))])
                  : _c("span", [_vm._v("0")]),
                _vm._v(" de " + _vm._s(_vm.maxlength) + " ")
              ]
            )
          : _vm._e()
      ]),
      _vm.error
        ? _c("error", {
            attrs: { message: _vm.customErrorMsg, variant: "no-border" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }